export const getLangheData = () => ({
  name: "Langhe",
  country: "Italie",
  region: "Piémont",
  description: "Les Langhe sont le berceau du Barolo et du Barbaresco, produisant les vins rouges les plus prestigieux d'Italie avec le cépage Nebbiolo.",
  type: "subregion",
  mapAreas: [
    { region: "Langhe", x: 48, y: 44, color: "#4B164C", size: 5 }
  ],
  statistics: {
    totalArea: "8,000 ha",
    production: "300,000 hl",
    wineries: "400+ domaines",
    villages: "11 communes historiques",
    exportPercentage: "80%"
  },
  characteristics: {
    climate: "Climat continental tempéré, étés chauds, hivers froids",
    soil: "Sols calcaires et argilo-calcaires, tufo",
    viticulture: "Vendanges manuelles, cépages autochtones, DOCG stricte"
  },
  wineStyles: {
    red: "Rouges puissants et structurés, tannins fermes, grande capacité de garde"
  },
  history: "Les Langhe sont le cœur historique du Piémont viticole. Le Barolo et le Barbaresco sont les vins les plus prestigieux d'Italie.",
  foodPairing: "Truffes blanches, risotto, viandes rouges, fromages affinés",
  grapeVarieties: [
    {
      name: "Nebbiolo",
      percentage: "70%",
      description: "Cépage roi du Piémont, produisant des vins complexes et structurés",
      characteristics: "Complexe, tanins fermes, notes de rose et de truffe",
      wineStyles: "Sec, plein-corps, tannique"
    },
    {
      name: "Barbera",
      percentage: "20%",
      description: "Cépage d'assemblage, apportant acidité et fruité",
      characteristics: "Acidité vive, fruité, tanins doux, notes de cerise",
      wineStyles: "Sec, moyen-corps, fruité"
    },
    {
      name: "Dolcetto",
      percentage: "8%",
      description: "Cépage d'assemblage, apportant douceur et fruité",
      characteristics: "Doux, fruité, tanins soyeux, notes de fruits rouges",
      wineStyles: "Sec, moyen-corps, fruité"
    },
    {
      name: "Arneis",
      percentage: "2%",
      description: "Cépage blanc pour les vins blancs",
      characteristics: "Sec, aromatique, notes d'agrumes et de fleurs",
      wineStyles: "Sec, léger, aromatique"
    }
  ]
}); 